import { createAction } from '@reduxjs/toolkit';
import { QHistory } from '../models/QHistory';

const PUSH_RECENT = 'PUSH_RECENT';

export const pushRecent = createAction<QHistory>(PUSH_RECENT);
